"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMyDocuments = void 0;
var keys_1 = require("../keys");
var profile_api_1 = require("@l2p/profile-api");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var useMyDocuments = function (payload) {
    var _a = (0, useQuery_1.useQuery)({
        payload: payload,
        path: payload.type === profile_api_1.DocumentTypeEnum.Identity
            ? keys_1.GET_MY_DOCUMENTS_IDENTITY
            : payload.type === profile_api_1.DocumentTypeEnum.Address
                ? keys_1.GET_MY_DOCUMENTS_ADDRESS
                : keys_1.GET_MY_DOCUMENTS_PAYMENT,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useMyDocuments = useMyDocuments;
